export const classProgramFunc = (program) => {
  if (!program) return [];

  switch (program.value) {
    case "תכשיטנות":
      return [
        { value: 0, label: "מתקדמים" },
        { value: 1, label: "מתחילים" },
      ];
      case "אקרו ברייקדאנס":
      return [
        { value: 0, label: "מתקדמים" },
        { value: 1, label: "מתחילים" },
      ];
    
    case "תפירה ועיצוב אופנה":
      return [
        { value: 0, label: "כיתות א-ב" },
        { value: 1, label: "כיתות ג-ד" },
        { value: 2, label: "כיתות ה-ו" },
      ];

    case "כדורעף":
      return [
        { value: 0, label: "בנות כיתות ה-ו" },
        { value: 1, label: "בנים כיתות ה-ו" },
        { value: 2, label: "כיתות א-ב" },
        { value: 3, label: "בנות/בנים כיתות ג-ד" },
      ];
    case "חוג מחשבים קייטנת חנוכה":
      return [
        { value: 0, label: "4 ימים" },
        { value: 1, label: "17-18/12" },
        { value: 2, label: "21-22/12" },
      ]
    case "התעמלות אומנותית":
      return [
        { value: 0, label: "כיתות ג ומעלה" },
        { value: 1, label: "כיתות א-ב" },
        { value: 2, label: "גן ט חובה + חובה" },
      ];

    case "התעמלות קרקע ואקרובטיקה":
      return [
        { value: 0, label: "כיתות א-ו" },
      ];

    case "לגו מכאני":
      return [
        { value: 0, label: "כיתות א-ב" },
        { value: 1, label: "כיתות ג-ו" },
      ];
    case "יוגה לילדים":
      return [
        { value: 0, label:  "קבוצת גן" },
        { value: 1, label: "כיתות א-ב " },
        { value: 2, label: "כיתות ג " },
      ];
    case "כדורגל":
      return [
        { value: 0, label: "כיתות ג-ד" },
        { value: 1, label: "כיתות א-ב מתחילים" },
        { value: 2, label: "כיתות א-ב מתקדמים" },
      ];
    case "אומנות ומלאכה":
      return [
        { value: 2, label: "כיתות א-ב" },
        { value: 1, label: "כיתות ג-ד" },
        { value: 2, label: "כיתות ה-ו" },
      ]
    case "מבוכים ודרקונים":
      return [
        { value: 0, label: "כיתות ב-ג" },
        { value: 1, label: "כיתות ד-ו" },
      ];

    case "כלבנות ואילוף כלבים":
      return [
        { value: 0, label: "כיתות ג-ו" },
        { value: 1, label: "כיתות א-ב" },
      ];

    case "סטודיו מיתרים":
      return [
        { value: 0, label: "פרטני בתיאום אישי" },
        { value: 1, label: "גילאי 7-18" },
        { value: 2, label: "30 דקות" },

      ];

    case "אלקטרוניקה":
      return [
        { value: 0, label: "כיתות א-ד" },
      ];

    case "שחמט":
      return [
        { value: 0, label: "מתחילים" },
        { value: 1, label: "מתקדמים" },
      ];

    case "גומי קליי":
      return [
        { value: 0, label: "כיתות א-ג" },
      ];

    case "מתמטיקה":
      return [
        { value: 0, label: "כיתות ו" },
      ];
    case "פינת חי":
      return [
        { value: 0, label: "כיתות א-ב" },
        { value: 1, label: "כיתות ג-ד" },
	      { value: 2, label: "ילדי גן"},
      ];

    case "משקיעי העתיד":
      return [
        { value: 0, label: "כיתות ג-ד" },
        { value: 1, label: "כיתות ה-ו" },
      ];

    case "מחשבים":
      return [
        { value: 0, label: "כיתות ה-ו" },
        { value: 1, label: "כיתות ג-ד" },
        { value: 2, label: "כיתות א-ב" },
      ];

    case "ג׳ודו":
      return [
        { value: 0, label: "כיתות ג-ד" },
        { value: 1, label: "כיתות ב" },
        { value: 2, label: "כיתות א" },
        { value: 3, label: "גנים" },
        { value: 4, label: "כיתות א-ב" },
        { value: 5, label: "כיתות א-ד" },
        { value: 6, label: "כיתות ב-ד" },
        { value: 7, label: "כיתות ה ומעלה" },
      ];

    case "כדוריד":
      return [
        { value: 0, label: "כיתות ג-ד" },
        { value: 1, label: "כיתות ה-ו" },
      ];

    case "רובוטיקה":
      return [
        { value: 0, label: "כיתות ה-ו" },
      ];
    case "מצוינות בספורט עולים לד- דמי רישום":
      return [
        { value: 0, label: "מצוינות בספורט עולים לד- דמי רישום" },

      ]
    case "מצויינות בספורט":
      return [
        { value: 0, label: "כיתות ג" },
        { value: 1, label: "כיתות ד" },
      ]
    case "מצוינות בספורט עולים לג- דמי רישום":
      return [
        { value: 0, label: "מצוינות בספורט עולים לג- דמי רישום" },

      ]
    default:
      return [
        { value: 0, label: "כללי" },
      ];
  }
};
